<template>
  <img src="@/assets/images/henza.svg" alt="هنزاگلد" :width="width" :height="height">
</template>

<script>
//import logo from "/components//"
export default {
  name: "Logo",
  props: {
    width: {
      type: String,
      default: '120px',
      //required: true
    },
    height: {
      type: String,
      default: '120px',
      //required: true
    },
  }
}
</script>

<style scoped>

</style>
